//Token Service
const TokenService = (function() {
  var _service;

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _setToken(token) {
    localStorage.setItem('access_token', token);
  }

  function _getAccessToken() {
    return localStorage.getItem('access_token');
  }

  function _clearToken() {
    localStorage.removeItem('access_token');
  }

  function _isTokenExpired(decodedToken) {
    let expiredToken = false;
    const now = Date.now().valueOf() / 1000;
    if (typeof decodedToken.exp !== 'undefined' && decodedToken.exp < now) {
      expiredToken = true;
    }

    return expiredToken;
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    clearToken: _clearToken,
    isTokenExpired: _isTokenExpired
  };
})();

export default TokenService;
